// Global Instructions Rule Applied!

import { FieldTypeEnum } from '../../../core/components/InputManager/types.ts'
import * as dealsTableMapper from './dealsTableMapper.ts'
import * as companiesTableMapper from './companiesTableMapper.ts'
import * as contactsTableMapper from './contactsTableMapper.ts'
import * as fundraisingTableMapper from './fundraisingTableMapper.ts'

export type TableInputManagerModule = 'deals' | 'companies' | 'contacts' | 'fundraising'

const FUNDRAISING_REPORTING_MODULE_KEYS = new Set([
  'prospects',
  'funds',
  'pipeline_prospects',
  'contact_prospects',
  'contact_accounts'
])

/**
 * Maps `cfg.reporting_columns.module_key` to the shared table mapper module for the host grid.
 */
export function reportingModuleKeyToTableInputManagerModule(
  reportingModuleKey: string | undefined,
  hostTableModule: TableInputManagerModule
): TableInputManagerModule {
  if (!reportingModuleKey) {
    return hostTableModule
  }
  if (reportingModuleKey === 'accounts') {
    return 'companies'
  }
  if (reportingModuleKey === 'contacts') {
    return 'contacts'
  }
  if (reportingModuleKey === 'deals') {
    if (hostTableModule === 'fundraising') {
      return 'fundraising'
    }
    return 'deals'
  }
  if (reportingModuleKey === 'rounds') {
    if (hostTableModule === 'fundraising') {
      return 'fundraising'
    }
    if (hostTableModule === 'companies') {
      return 'companies'
    }
    return 'deals'
  }
  if (FUNDRAISING_REPORTING_MODULE_KEYS.has(reportingModuleKey)) {
    return 'fundraising'
  }
  return hostTableModule
}

export function mapColumnToInputManagerField(
  module: TableInputManagerModule,
  column: any,
  record: any,
  helpers: any,
  fieldType: FieldTypeEnum
): any {
  switch (module) {
    case 'deals':
      return dealsTableMapper.mapColumnToInputManagerField(column, record, helpers, fieldType)
    case 'companies':
      return companiesTableMapper.mapColumnToInputManagerField(column, record, helpers, fieldType)
    case 'contacts':
      return contactsTableMapper.mapColumnToInputManagerField(column, record, helpers, fieldType)
    case 'fundraising':
      return fundraisingTableMapper.mapColumnToInputManagerField(column, record, helpers, fieldType)
    default: {
      const _exhaustive: never = module
      return _exhaustive
    }
  }
}

export function mapValidationErrors(
  module: TableInputManagerModule,
  cellEditErrors: Record<string, any>,
  recordId: string
): Record<string, string> {
  switch (module) {
    case 'deals':
      return dealsTableMapper.mapValidationErrors(cellEditErrors, recordId)
    case 'companies':
      return companiesTableMapper.mapValidationErrors(cellEditErrors, recordId)
    case 'contacts':
      return contactsTableMapper.mapValidationErrors(cellEditErrors, recordId)
    case 'fundraising':
      return {}
    default: {
      const _exhaustive: never = module
      return _exhaustive
    }
  }
}

export function handleAutoPopulation(
  module: TableInputManagerModule,
  fieldKey: string,
  newValue: any,
  record: any,
  updateField: (key: string, value: any) => void,
  helpers: any
): void {
  switch (module) {
    case 'deals':
      dealsTableMapper.handleAutoPopulation(fieldKey, newValue, record, updateField, helpers)
      return
    case 'companies':
      companiesTableMapper.handleAutoPopulation(fieldKey, newValue, record, updateField, helpers)
      return
    case 'contacts':
      contactsTableMapper.handleAutoPopulation(fieldKey, newValue, record, updateField, helpers)
      return
    case 'fundraising':
      return
    default: {
      const _exhaustive: never = module
      return _exhaustive
    }
  }
}
